exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-mask{position:fixed;z-index:9000;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.5);transition:opacity .3s ease;overflow-x:hidden;overflow-y:auto}.modal-wrapper{position:relative;margin:20px auto;top:40px;transition:all .3s ease}.modal-container{margin:0 auto;padding:10px 20px;background-color:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.33)}.modal-header h3{margin-top:0;color:#42b983}.modal-body{margin:10px 0;padding:5px 15px}.modal-default-button{float:right}.modal-enter,.modal-leave{opacity:0}.modal-enter .modal-wrapper,.modal-leave .modal-wrapper{top:-5pc}@media screen and (max-width:767px){.modal-wrapper{top:20px}.modal-enter .modal-wrapper,.modal-leave .modal-wrapper{opacity:0;top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/modal.vue
// module id = 56
// module chunks = 0